import { Injectable } from '@angular/core';
import { TriggerbeeRequester } from '../../core/triggerbee/triggerbee-requester.service';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { Automation, TriggerCondition } from './../automations-models';
import { AutomationsService } from '../automations.service';
import { Subject } from 'rxjs';

@Injectable()
export class CreateAutomationService {
  private readonly logger: Logger;
  private readonly noSorting = 999;
  private readonly maxItems = 6;
  public automation: Automation;
  private refreshConditionsSource = new Subject<TriggerCondition[]>();
  refreshConditions$ = this.refreshConditionsSource.asObservable();

  constructor(
    loggerFactory: LoggerFactory,
    private readonly requester: TriggerbeeRequester,
    private readonly automationsService: AutomationsService,
  ) {
    this.logger = loggerFactory.get('CreateAutomationService');

    this.createNewAutomation();
  }

  public async createNewAutomation() {
    this.automation = new Automation();
    this.automation.triggers = [];
    this.automation.actions = [];
  }

  public async fillAutomation(id: string) {
    this.automation = await this.automationsService.getAutomation(id);
  }

  public async getAutomation() {
    return this.automation;
  }

  public async saveAutomation(automation: Automation) {
    return await this.automationsService.saveAutomation(automation);
  }

  public showInputFieldBasedOnOperator(trigger: TriggerCondition): boolean {
    return trigger.operator !== 'IsNotEmpty' && trigger.operator !== 'IsEmpty';
  }
}
